import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { EmeraldError } from '../../common/api/emerald-error';
import { AbortedError, ProhibitActionError } from '../../common/api/extended-emerald-error';
import { InterventionsNotFound } from '../../common/helpers/error-code';
import { store } from '../../common/redux/configure-store';
import { InterventionsActions } from '../../common/redux/reducers/interventions-reducer';
import { IIntervention, IInterventionInfo } from '../interfaces/IIntervention';
import { interventionDelete } from './service/intervention-service';
import { voidInterventionRejectedItems } from './void-intervention-rejected-items';

export const deleteIntervention = async (intervention: IIntervention): Promise<void> => {
  await interventionDelete(intervention.interventionId, intervention.restriction)
    .then(() => {
      store.dispatch(InterventionsActions.removeIntervention(intervention.interventionId));
    })
    .catch(async err => {
      if (err instanceof EmeraldError) {
        if (err.code === InterventionsNotFound) {
          return;
        } else if (err instanceof ProhibitActionError) {
          return voidInterventionRejectedItems(err.data);
        } else if (
          err instanceof AbortedError &&
          getCurrentXLRConfig().voidItemWhenRejectIntervention
        ) {
          return voidInterventionRejectedItems([(intervention as IInterventionInfo).itemId]);
        }
      }
      throw err;
    });
};
